import React from 'react';
import { Input as ShadInput } from 'ui/shadcn/input';
import { cn } from 'lib/utils';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
    required?: boolean;
    fullWidth?: boolean;
}

const Input: React.FC<InputProps> = ({
    label,
    error,
    required,
    fullWidth = true,
    className = '',
    id,
    ...props
}) => {
    const inputId = id || (label ? `input-${label.replace(/\s+/g, '-')}` : undefined);

    return (
        <div className={cn('flex flex-col gap-1.5', fullWidth && 'w-full')}>
            {label && (
                <label
                    htmlFor={inputId}
                    className="text-sm font-medium text-neutral-700"
                >
                    {label}
                    {required && <span className="text-destructive ml-0.5">*</span>}
                </label>
            )}
            <ShadInput
                id={inputId}
                aria-invalid={Boolean(error)}
                className={className}
                {...props}
            />
            {error && (
                <span className="text-xs text-destructive">{error}</span>
            )}
        </div>
    );
};

export default Input;
